import { render, staticRenderFns } from "./HomeCarousel.vue?vue&type=template&id=048ac230"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"
import style0 from "./HomeCarousel.vue?vue&type=style&index=0&id=048ac230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports